import * as types from '../actionTypes/AddToCartInterstitialActionTypes';

const AddToCartInterstitialReducer = function AddToCartInterstitialReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case types.ADDTOCART_DETAILS_GET_SUCCESS:
            return action.cartDetailsResponse;
        case types.ADDTOCART_DETAILS_RESET:
            return {};
        default:
            return state;
    }
};

AddToCartInterstitialReducer.reducerName = 'addToCartInterstitialDetails';

export default AddToCartInterstitialReducer;
